import { render } from "./CatalogoAutomotrizView.vue?vue&type=template&id=44277140&scoped=true"
import script from "./CatalogoAutomotrizView.vue?vue&type=script&lang=js"
export * from "./CatalogoAutomotrizView.vue?vue&type=script&lang=js"

import "./CatalogoAutomotrizView.vue?vue&type=style&index=0&id=44277140&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44277140"]])

export default __exports__